export default {
  // ========== Tabs ==========
  institutional: 'Institucional',
  forThe: 'para el',

  // ========== Botones de copia ==========
  copyThe: 'Copiar la',
  ofThe: 'del',
  copyConfirmTitle: '¿Copiar la planificación?',
  copyConfirmText:
    'Las sesiones existentes en el destino serán reemplazadas por las de la planificación copiada.',
  copyError: 'No fue posible copiar la planificación. Intente nuevamente.',
};
